import image1 from "../assets/fivepose.jpeg";
import image2 from "../assets/grapevine.jpeg";
import image3 from "../assets/kayla.png";
import image4 from "../assets/ninepose.png";
import image5 from "../assets/threeawards.png";
import image6 from "../assets/ninepose.png";
import image7 from "../assets/juneteenth.png";
import image8 from "../assets/podium.png";
import image9 from "../assets/circles.jpeg";
import image10 from "../assets/booth.jpeg";
import image11 from "../assets/communitynight.jpeg";
import image12 from "../assets/Recognition.jpeg";




export const galleryImages = [
        {
            src: image1,
            alt: "Milpitas Juneteenth 2024",
            title: "Milpitas Juneteenth",
            description: "2024"
        },
        {
            src: image2,
            alt: "Grant from Grapevine",
            title: "Grant from Grapevine",
            description: "2025"
        },
        {
            src: image3,
            alt: "Kayla Choates, Mistress of Ceremonies for Milpitas Juneteenth 2025",
            title: "Kayla Choates, Mistress of Ceremonies for Milpitas Juneteenth",
            description: "2025"
        },
        // {
        //     src: image1,
        //     alt: "Community members taking pictures for the Assembly Award",
        //     // title: "4",
        //     // description: "Volunteers helping families in need"
        // },
        {
            src: image5,
            alt: "Milpitas Flag Raising Ceremony",
            title: "Milpitas Flag Raising Ceremony",
            description: "February 2024"
        },
        {
            src: image4,
            alt: "Milpitas Flag Raising Ceremony",
            title: "Milpitas Flag Raising Ceremony",
            description: "February 2024"
        },
        {
            src: image7,
            alt: "Milpitas Juneteenth 2024",
            title: "Milpitas Juneteenth 2024",
            description: "2024"
        },
        {
            src: image8,
            alt: "Milpitas Juneteenth 2024",
            title: "Milpitas Juneteenth",
            description: "2024"
        },
        {
            src: image9,
            alt: "Our Founder on a Back Black Speaking Panel",
            title: "Our Founder on a Back Black Speaking Panel",
            // description: "2024"
        },
            {
            src: image10,
            alt: "Community Outreach",
            title: "Community Outreach for MUSD",
            description: "2025"
        },
        {
            src: image11,
            alt: "Community Night wit MUSD",
            title: "Community Night wit MUSD",
            // description: "Experienced parent mentoring newcomer"
        },
        {
            src: image12,
            alt: "Recognition by Assembly of California",
            title: "Recognition by Assembly of California",
            description: "2024"
        }
    ];